// eslint-disable-next-line import/no-unresolved
import * as $ from 'jquery';
import EmblaCarousel from 'embla-carousel';
import magicLine from '../helpers/magic-line';
import { setupPrevNextBtns, disablePrevNextBtns } from '../helpers/carousel-buttons';

(() => {
  const serviceCarousel = document.querySelectorAll('.m10');

  /**
   * Init magic line
   */
  const magicLineInstance = new magicLine('.m10__filters', {
    navElements: 'label',
    lineStrength: 2
  });
  magicLineInstance.init();

  const initialiseCarousel = carousel => {
    const viewport = carousel.querySelector('.m10__items');

    if (viewport === null) {
      return;
    }
    const slides = viewport.querySelectorAll('.m10__slide');
    const isLessThanThree = slides.length <= 3 && window.outerWidth >= 810;

    const options = {
      slidesToScroll: 1,
      align: isLessThanThree ? 'center' : 'start',
      startIndex: isLessThanThree ? 1 : 0,
      draggable: true,
      containScroll: isLessThanThree ? '' : 'trimSnaps'
    };

    // Embla functions.
    const embla = EmblaCarousel(viewport, options);

    const prevBtn = carousel.querySelector('.m10__button--prev');
    const nextBtn = carousel.querySelector('.m10__button--next');
    const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);

    setupPrevNextBtns(prevBtn, nextBtn, embla);

    embla.on('init', () => {
      if (! isLessThanThree) {
        disablePrevAndNextBtns();
      }
    }
    );
    embla.on('select', () => {
      if (! isLessThanThree) {
        disablePrevAndNextBtns();
      }
    });

    if (isLessThanThree) {
      prevBtn.setAttribute('disabled', 'disabled');
      nextBtn.setAttribute('disabled', 'disabled');
    }
  };

  serviceCarousel.forEach(carousel => {
    initialiseCarousel(carousel);
  });

  /**
   * Re-initialise scripts after Terra is done
   */
  $('body').on('terraDone', (event, $container) => {
    if ($container.parents('.m10')[0]) {
      initialiseCarousel($container.parents('.m10')[0]);
    }
  });
})();